import React, { useState } from 'react';
import { Box, Flex, theme, Text } from '@xometry/xometry_loft';
import UserInitial from '../../../../components/UserInitialBox';
import Table from '../../../../components/Table';
import getEventText from './eventDefinitions';
import { OrganizationUser } from '../../../../schema/generated/schema';

const EventLog = ({
  events,
  orgName,
  orgUsers,
}: {
  events: [any];
  orgName: string | null;
  orgUsers: OrganizationUser[];
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const MAX_PAGE_COUNT = 5;
  const EventLogColumns = () => {
    const formatDate = (dateString: string) => {
      const newDate = new Date(dateString);
      return `${
        newDate.getMonth() + 1
      }/${newDate.getDate()}/${newDate.getFullYear()}`;
    };

    const getActorRole = (event) => {
      if (event.actorIsStaff) {
        return 'staff';
      }
      const actorId = event.actor.userId;
      const userMatch = orgUsers.filter((orgUser) => orgUser.userId == actorId);
      return userMatch[0]?.role?.name || '';
    };

    const compileInitials = (event) => {
      if (event.actorIsStaff) {
        return 'X';
      } else {
        return `${event.actor.firstName} ${event.actor.lastName}`;
      }
    };

    const compileName = (event) => {
      if (event.actorIsStaff) {
        return 'Xometry Staff';
      } else {
        return `${event.actor.firstName} ${event.actor.lastName}`;
      }
    };

    return [
      {
        Header: 'Performed By',
        accessor: 'actor',
        Cell: ({ cell }: { cell: Cell }) => (
          <Flex fontSize="13px">
            <Box marginRight="10px">
              <UserInitial
                fullName={compileInitials(cell.row.original)}
                role={getActorRole(cell.row.original)}
                size={40}
              />
            </Box>
            <Flex flexDirection="column" justifyContent="center">
              <Box fontWeight={theme.fontWeights.semibold}>
                {compileName(cell.row.original)}
              </Box>
            </Flex>
          </Flex>
        ),
      },
      {
        Header: 'Event Description',
        accessor: 'type',
        Cell: ({ cell }: { cell: Cell }) => (
          <Flex>
            <Text>{getEventText(cell.row.original, orgName)}</Text>
          </Flex>
        ),
      },
      {
        Header: <Flex>Date</Flex>,
        accessor: 'date',
        Cell: ({ cell }: { cell: Cell }) => (
          <Flex>
            <Text>{formatDate(cell.value)}</Text>
          </Flex>
        ),
      },
    ];
  };

  return (
    <Flex
      color={theme.colors.darkBlues[100]}
      fontSize="13px"
      flexDirection="column"
    >
      <Table
        data={[...events].slice(
          (currentPage - 1) * MAX_PAGE_COUNT,
          currentPage * MAX_PAGE_COUNT
        )}
        columns={EventLogColumns()}
        selectedPage={currentPage}
        setSelectedPage={setCurrentPage}
        pageSize={MAX_PAGE_COUNT}
        recordPageCount={Math.ceil(events.length / MAX_PAGE_COUNT)}
        isReadOnly
      />
    </Flex>
  );
};

export default EventLog;
